'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var _actions = ['SET_INSTANCE'];

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(_actions);
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(_actions);